import Loader from '../common/Loader';
import styles from './PendingAlert.scss';

interface PendingAlertProps {
  title: string;
  description: string;
}

const PendingAlert = ({ title, description }: PendingAlertProps) => (
  <div className={styles.box}>
    {title ? <h2 className={styles.title}>{title}</h2> : null}

    {description ? <p className={styles.description}>{description}</p> : null}

    <Loader colored size={50} />
  </div>
);

export default PendingAlert;
